import { GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS, GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR, GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR, GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS, GET_QUOTE_FUNNELS_SOURCE_STATS, GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR, GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS } from "./actionTypes";
import { DASHBOARD_API_CALL_TYPE } from "helpers/sf_constants";

const initialState = {
  qf_main_data: {},
  qf_state_wise_metrics: [],
  qf_source_type_wise_metrics: [],
  qf_creative_wise_metrics: [],
  qf_date_ranges: [],
  qf_compare_to_main_data: [],
  qf_lead_type_wise_metrics: [],

  qf_analytics_data: [],
  qf_analytics_loading: [],
  qf_analytics_error: [],
  qf_campaigns_data: [],
  qf_campaigns_loading: [],
  qf_campaigns_error: [],
  qf_agg_campaigns_data: [],
  qf_agg_campaigns_loading: false,
  qf_agg_campaigns_error: [],
  qf_adgroups_data: [],
  qf_adgroups_loading: [],
  qf_adgroups_error: [],
  qf_source_settings_data: [],
  qf_source_settings_loading: [],
  qf_source_settings_error: [],
  qf_creatives_data: [],
  qf_creatives_loading: [],
  qf_creatives_error: [],
  qf_source_stats_data: [],
  qf_source_stats_loading: false,
  qf_source_stats_error: null,

  loading: {
    [DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: false,
    [DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: false
  },

  error: {
    [DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES]: null,
    [DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA]: null
  }
};

const apiTypeToReducerField = (api_type) => {
  return api_type.replace('fetch_', 'qf_');
}

const apiTypeToReducerFieldForConversions = (api_type) => {
  return api_type.replace('fetch_', 'conversions_');
}

const quoteFunnelsStatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD:
      return {
        ...state,
        error: null,
        qf_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_MAIN_DATA ? [] : state.qf_main_data,
        qf_state_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_STATE_WISE_METRICS ? [] : state.qf_state_wise_metrics,
        qf_source_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_SOURCE_TYPE_WISE_METRICS ? [] : state.qf_source_type_wise_metrics,
        qf_creative_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_CREATIVE_WISE_METRICS ? [] : state.qf_creative_wise_metrics,
        qf_lead_type_wise_metrics: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_INSURNCE_TYPE_WISE_METRICS ? [] : state.qf_lead_type_wise_metrics,
        qf_date_ranges: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_DATE_RANGES ? [] : state.qf_date_ranges,
        qf_compare_to_main_data: action.api_type === DASHBOARD_API_CALL_TYPE.FETCH_COMPARE_TO_MAIN_DATA ? [] : state.qf_compare_to_main_data,

        loading: {
          ...state.loading, [action.api_type]: true
        },
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_SUCCESS:
      return {
        ...state,
        error: null,
        [apiTypeToReducerField(action.api_type)]: action.payload,
        loading: {
          ...state.loading,
          [action.api_type]: false
        },
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_DASHBOARD_ERROR:
      return {
        ...state,
        error: null,
        loading: true,
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS:
      return {
        ...state,
        qf_analytics_loading: true,
        qf_analytics_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_SUCCESS:
      return {
        ...state,
        qf_analytics_data: action.payload,
        qf_analytics_loading: false,
        qf_analytics_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_ANALYTICS_ERROR:
      return {
        ...state,
        qf_analytics_loading: false,
        qf_analytics_error: action.payload
      }

      case GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS:
      return {
        ...state,
        qf_campaigns_loading: true,
        qf_campaigns_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        qf_campaigns_data: action.payload,
        qf_campaigns_loading: false,
        qf_campaigns_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR:
      return {
        ...state,
        qf_campaigns_loading: false,
        qf_campaigns_error: action.payload
      }
      
      // camapign aggregated data for goal/quote_funnels

    case GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS:
      return {
        ...state,
        qf_agg_campaigns_loading: true,
        qf_agg_campaigns_error: null
      }

    case GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        qf_agg_campaigns_data: action.payload,
        qf_agg_campaigns_loading: false,
        qf_agg_campaigns_error: null
      }

    case GET_AGG_QUOTE_FUNNELS_STATS_FOR_CAMPAIGNS_ERROR:
      return {
        ...state,
        qf_agg_campaigns_loading: false,
        qf_agg_campaigns_error: action.payload
      }

      // camapign aggregated data for goal/quote_funnels ends

      case GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS:
      return {
        ...state,
        qf_adgroups_loading: true,
        qf_adgroups_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_SUCCESS:
      return {
        ...state,
        qf_adgroups_data: action.payload,
        qf_adgroups_loading: false,
        qf_adgroups_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_ADGROUPS_ERROR:
      return {
        ...state,
        qf_adgroups_loading: false,
        qf_adgroups_error: action.payload
      }

      case GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS:
      return {
        ...state,
        qf_source_settings_loading: true,
        qf_source_settings_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_SUCCESS:
      return {
        ...state,
        qf_source_settings_data: action.payload,
        qf_source_settings_loading: false,
        qf_source_settings_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_SOURCE_SETTINGS_ERROR:
      return {
        ...state,
        qf_source_settings_loading: false,
        qf_source_settings_error: action.payload
      }

      case GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES:
      return {
        ...state,
        qf_creatives_loading: true,
        qf_creatives_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_SUCCESS:
      return {
        ...state,
        qf_creatives_data: action.payload,
        qf_creatives_loading: false,
        qf_creatives_error: null
      }

    case GET_QUOTE_FUNNELS_STATS_FOR_CREATIVES_ERROR:
      return {
        ...state,
        qf_creatives_loading: false,
        qf_creatives_error: action.payload
      }

    case GET_QUOTE_FUNNELS_SOURCE_STATS:
      return {
        ...state,
        qf_source_stats_loading: true,
        qf_source_stats_error: null
      }

    case GET_QUOTE_FUNNELS_SOURCE_STATS_SUCCESS:
      return {
        ...state,
        qf_source_stats_data: action.payload,
        qf_source_stats_loading: false,
        qf_source_stats_error: null
      }

    case GET_QUOTE_FUNNELS_SOURCE_STATS_ERROR:
      return {
        ...state,
        qf_source_stats_loading: false,
        qf_source_stats_error: action.payload
      }

    default:
      return state;
  }
};

export default quoteFunnelsStatsReducer;
